import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import WhyChooseUsSection from "./WhyChooseUsSection";
import ImpactMetricsSection from "./ImpactMetricsSection";
import NewsSection from "./NewsSection";
import Footer from "../../component/common/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import MediaSection from "./Media";
import Clients from "./Clients";

const Homepage = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 200,
      disable: false, // Ensure it's not disabled
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Sustainable Energy Solutions & Organic Fertilizers | Govardhannathji
          Energies LLP
        </title>
        <meta
          name="description"
          content="Leading sustainable energy solutions with 500+ farms transformed, 20k+ waste converted to energy. Govardhannathji Energies LLP provides organic fertilizers & bio gas energy for greener tomorrow."
        />
        <meta
          property="og:title"
          content="Sustainable Energy Solutions & Organic Fertilizers | Govardhannathji Energies LLP"
        />
        <meta
          property="og:description"
          content="Leading sustainable energy solutions with 500+ farms transformed, 20k+ waste converted to energy. Govardhannathji Energies LLP provides organic fertilizers & bio gas energy for greener tomorrow."
        />
      </Helmet>

      <main>
        <HeroSection />
        {/* <AboutSection /> */}
        <ServicesSection />
        <WhyChooseUsSection />
        <ImpactMetricsSection />

        <NewsSection />
        <MediaSection />
        <Clients />
        <Footer />
      </main>
    </>
  );
};

export default Homepage;
